import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.promise";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.set";
var customCache = new Set();
export function useIconfont(_x) {
  return _useIconfont.apply(this, arguments);
}

function _useIconfont() {
  _useIconfont = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(scriptUrl) {
    var script;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl))) {
              _context.next = 8;
              break;
            }

            script = document.createElement('script');
            script.setAttribute('src', scriptUrl);
            script.setAttribute('data-namespace', scriptUrl);
            customCache.add(scriptUrl);
            document.body.appendChild(script);
            _context.next = 8;
            return new Promise(function (resolve, reject) {
              script.onload = resolve;
              script.onerror = reject;
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _useIconfont.apply(this, arguments);
}